import { memo } from 'react';

import { Close } from '@radix-ui/react-dialog';

import CloseIcon from '~/icons/close.svg';
import { Text } from '~/shared/components/Text/Text';

import styles from './searchDialogContent.module.css';

type Props = {
	label?: string;
	onCloseClick?: () => void;
};

export const CloseButton = memo(({ label, onCloseClick }: Props) => (
	<Close asChild>
		<button
			type="button"
			className={styles.closeButton}
			onClick={onCloseClick}
			aria-label="Close"
		>
			<span className={styles.closeButtonContent}>
				<CloseIcon />
				{label && <Text variant="label">{label}</Text>}
			</span>
		</button>
	</Close>
));
